export const faqs = [
  {
    q: "How will I receive the materials?",
    a: ["GI Nutrition Clinical Blueprint™ is a digital educational collection.", "After checkout, your access details will be sent to the email address you provide. The checkout page explains how you'll receive your purchase and access the included materials."],
  },
  {
    q: "What exactly is included?",
    a: ["Your purchase includes six specialized educational volumes and five complementary resources covering gastrointestinal physiology, nutritional assessment, dietary considerations, gastrointestinal conditions, educational case analysis, nutrition care planning, and documentation.", "The complete contents are listed on this page."],
  },
  {
    q: "Is this a physical product?",
    a: ["No. This is a digital educational collection. No physical book or printed materials will be shipped."],
  },
  {
    q: "Who is this collection for?",
    a: ["It is intended for nutrition professionals, dietitians, nutrition students, and other eligible learners who want to organize their study of gastrointestinal nutrition.", "The collection is not a substitute for formal education, supervised training, or professional qualifications."],
  },
  {
    q: "Is this a complete clinical training course?",
    a: ["No. GI Nutrition Clinical Blueprint™ is an educational reference collection, not a comprehensive clinical training course or certification program.", "It is designed to complement professional learning and the organization of educational resources."],
  },
  {
    q: "Does this collection provide individualized nutrition prescriptions?",
    a: ["No. It does not provide individualized treatment plans, diagnose gastrointestinal conditions, or prescribe diets for specific patients.", "Nutrition care decisions require appropriate professional assessment and current evidence-based guidance."],
  },
  {
    q: "Can I use the materials in any country?",
    a: ["The educational references may be useful to learners in different countries. However, clinical guidance, professional standards, documentation requirements, and applicable regulations vary by jurisdiction.", "You should consult current local guidance and adapt educational materials to your professional scope."],
  },
  {
    q: "Can I download the files?",
    a: ["The collection is offered digitally. The exact file formats and access instructions will be provided at checkout."],
  },
  {
    q: "Is this a recurring subscription?",
    a: ["No. The advertised price is a one-time payment for the included digital collection. There is no recurring subscription."],
  },
  {
    q: "What if I decide the collection isn't right for me?",
    a: ["Please review the refund policy and eligibility requirements displayed at checkout before purchasing. Your applicable rights and refund conditions will be explained there."],
  },
  {
    q: "Does this collection guarantee better clinical outcomes?",
    a: ["No. The collection is designed to support professional education and reference organization. It does not guarantee clinical outcomes, diagnostic accuracy, or treatment effectiveness."],
  },
];
